import { Stack, Spinner } from '@chakra-ui/react';
import { ReactElement } from 'react';

export const PageSpinner = (): ReactElement => {
  return (
    <Stack align="center" height="100vh" display="flex" justifyContent="center" alignItems="center">
      <Spinner
        m="10%"
        borderWidth="7px"
        animationDuration="1s"
        // emptyColor="border.accent"
        color="text.accent"
        size="xl"
      />
    </Stack>
  );
};
